<template>
  <div class="container-fluid">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>
          Notifications
        </h1>
      </div>
    </div>
    <div class="dashboard-block">
        <pickstar-loading v-if="fetchingNotifications" class="m-t-lg"/>

        <no-results v-if="haveNoNotifications">
          <div>There are no notifications.</div>
        </no-results>

        <ul class="item-detail list-links">
          <notification-feed-item
            v-for="notification in notifications"
            :key="notification.id"
            :notification="notification"/>
        </ul>

        <lazy-loading
          class="text-center"
          :loading="loading"
          :reached-bottom="handleGetNextNotificationsCallback"
          ref="lazyLoading">
          <pickstar-loading slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
    </div>
  </div>
</template>
<script>
import NotificationFeedItem from './NotificationFeedItem'
import LazyLoading from 'codium-lazy-loading'
import { mapActions, mapState } from 'vuex'
import { CommonTracker } from 'mixins/analytics'

export default {
  components: {
    NotificationFeedItem,
    LazyLoading
  },
  mixins: [ CommonTracker ],
  data () {
    return {
      fetchingNotifications: false
    }
  },

  created () {
    this.handleGetNotificationsCallback().then(() => {
      this.readNotifications()
    })
    this.trackEvent(this.analytics.V2.NotificationListingViewEvent)
  },

  computed: {
    ...mapState('notifications', ['notifications']),
    ...mapState('app', ['loading']),

    haveNoNotifications () {
      return this.notifications.length === 0
    }
  },

  methods: {
    ...mapActions('notifications', ['getNotifications', 'getNextNotifications', 'readNotifications']),

    handleGetNotificationsCallback () {
      this.fetchingNotifications = true

      return this.getNotifications(this.queryParams ? this.queryParams : {})
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingNotifications = false

          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
    },

    handleGetNextNotificationsCallback () {
      return this.getNextNotifications(this.queryParams)
        .catch(this.handleServerErrorsCallback)
    }
  }
}
</script>
